import styled from "styled-components";
import {
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import {
  FONT_CSS,
  FONT_STYLE,
} from "../../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  SPACING,
} from "../../../constants/design/spacing";

export const PerformanceDetailsContainer = styled.div`
  ${FONT_CSS.header.seven}
  padding: ${SPACING.three}px;
`;

export const PerformanceDetailCard = styled.div`
  margin-top: ${SPACING.three}px;
  padding: ${SPACING.three}px;
  background-color: ${LAYER_COLORS.two};
  color: ${TEXT_COLORS.two};
  border-radius: ${BORDER_RADIUS.five}px;

  > div:first-child {
    span:first-child {
      ${FONT_CSS.body.five}
      color: ${TEXT_COLORS.one};
    }
  }

  > div {
    ${FONT_CSS.data.four}
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const PerformanceBarContainer = styled.div`
  position: relative;
`;

export const BarTrack = styled.div`
  background-color: ${LAYER_COLORS.three};
  height: 2px;
  border-radius: ${BORDER_RADIUS.five}px;
  width: 100%;
  margin: ${SPACING.three}px 0;
`;
export const OpenCloseTrack = styled.div<{ isNegative?: boolean }>`
  background-color: ${({ isNegative }) =>
    isNegative ? COLORS.down.three : COLORS.up.three};
  position: absolute;
  height: 2px;
  display: flex;
  align-items: center;
  justify-content: ${({ isNegative }) =>
    isNegative ? "flex-start" : "flex-end"};

  > div {
    height: 8px;
    width: 1px;
    background-color: ${({ isNegative }) =>
      isNegative ? COLORS.down.one : COLORS.up.one};
  }
`;

export const MarginTitle = styled.div`
  display: flex;

  > * {
    margin: auto 0;

    &:not(:last-child) {
      margin-right: ${SPACING.two}px;
    }
  }
`;

export const MarginDesc = styled.div`
  ${FONT_STYLE.body.three};
  color: ${TEXT_COLORS.two};
`;

export const MarginTypeText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: ${SPACING.two}px;
`;
